import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { LinearProgress, Typography, Box } from "@material-ui/core";
import isOnScreen from "../../../../lib/ScrollTrigger";

const useStyles = makeStyles((theme) => ({
  bottomMargin: {
    marginBottom: "4em",
  },
  root: {
    flexGrow: 1,
  },
  value: {
    color: "#202020",
    fontWeight: 600,
    fontSize: "1rem",
    marginBottom: "1rem",
  },
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 8,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    background: "linear-gradient( 90deg, #F74134 0%, #EB1C61 100%)",
  },
}))(LinearProgress);

const ProgressBar = ({ id, value, className, animation }) => {
  const classes = useStyles();
  const [bst, setBst] = React.useState(0);
  React.useEffect(() => {
    let st = false;
    isOnScreen(
      id,
      500,
      (state) => {
        if (state == "in-view" && !st && animation == "accelerate") {
          st = true;
          let i = 1;
          let j = 1;
          const interval = setInterval(() => {
            setBst(value * i);
            if (i + j > 10) i = 10;
            else i += j;
            j++;
            if (j == 10) clearInterval(interval);
          }, 100);
        } else if (state == "in-view" && !st && animation == "decelerate") {
          st = true;
          let i = 1;
          let j = 1;
          const interval = setInterval(() => {
            setBst(value * i);
            if (i + j > 10) i = 10;
            else i += j;
            j++;
            if (j == 10) clearInterval(interval);
          }, 100);
        }
      },
      true
    );
  }, []);
  return (
    <React.Fragment>
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <BorderLinearProgress
            id={id}
            className={className}
            variant="determinate"
            value={bst}
          />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" className={classes.value}>
            {(bst / 10).toFixed(1)}/10
          </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default ProgressBar;
